import Base from './base'
import apiDispatcher from '@/utils/api-dispatcher'
import { ROSTER_INDEX, EDIT, UPLOAD_IMAGE } from '@/utils/api-url'

export default class Roster extends Base {
  constructor(params = {}) {
    super(params)
    this.id = params['id'] || params['_id']
    this.athleteName = params['athleteName'] || ''
    this.position = params['position'] || []
    this.positionValue =
      params['positionValue'] ||
      (params['position'] && params['position'].map(p => p['_id'])) ||
      []
    this.heightInFeet = params['heightInFeet'] || 0
    this.heightInInch = params['heightInInch'] || 0
    this.gradeYear = params['gradeYear'] || undefined
    this.throwingHandName =
      params['throwingHand'] && params['throwingHand']['name']
    this.battingHandName =
      params['battingHand'] && params['battingHand']['name']
    this.stateName = params['state'] && params['state']['name']
    this.stateId =
      params['stateId'] ||
      (params['state'] && params['state']['_id']) ||
      undefined
    this.battingHandId =
      params['battingHandId'] ||
      (params['battingHand'] && params['battingHand']['_id']) ||
      undefined
    this.throwingHandId =
      params['throwingHandId'] ||
      (params['throwingHand'] && params['throwingHand']['_id']) ||
      undefined
  }

  height() {
    return `${this.heightInFeet}'${this.heightInInch}"`
  }

  static resourceName() {
    return 'roster'
  }

  static validationRules() {
    return {
      fname: {
        required: true,
        message: 'Please enter first name',
        trigger: 'blur'
      },
      lname: {
        required: true,
        message: 'Please enter last name',
        trigger: 'blur'
      },
      heightInFeet: {
        trigger: 'blur',
        type: 'number',
        message: 'Please enter height',
        required: true,
        validator: (_rule, value) => value > 0
      },
      profileLink: {
        trigger: 'blur',
        message: 'Please insert valid topnotch link',
        required: false,
        validator: (_rule, value) => {
          if (!value) return true
          try {
            let newUrl = new URL(value)
            return newUrl && newUrl.host === window.location.host
          } catch (e) {
            return false
          }
        }
      },
      positionValue: {
        required: true,
        message: 'Please select position',
        trigger: 'blur'
      },
      highSchool: {
        required: false,
        message: 'Please enter high school',
        trigger: 'blur'
      },
      city: { required: true, message: 'Please enter city', trigger: 'blur' },
      stateId: {
        required: true,
        message: 'Please select state',
        trigger: 'blur'
      },
      battingHandId: {
        required: true,
        message: 'Please select batting hand',
        trigger: 'blur'
      },
      throwingHandId: {
        required: true,
        message: 'Please select throwing hand',
        trigger: 'blur'
      },
      gradeYear: {
        required: true,
        message: 'Please select grade year',
        trigger: 'blur'
      }
    }
  }

  static index(params) {
    const clubId = params.clubId ? params.clubId : localStorage['club-id']
    let profileId = ''
    if (JSON.parse(localStorage['user-permissions']) === 'player')
      profileId = this.profileId()
    return apiDispatcher(
      ROSTER_INDEX(params.isActive, clubId, profileId, {
        ...params,
        isActive: null
      })
    )
  }

  static indexLimited(params) {
    const clubId = params.clubId ? params.clubId : localStorage['club-id']
    let profileId = ''
    if (JSON.parse(localStorage['user-permissions']) === 'player')
      profileId = this.profileId()
    return apiDispatcher(
      ROSTER_INDEX(params.isActive, clubId, profileId, {
        ...params,
        isActive: null,
        limit: 4,
        page: 1
      })
    )
  }

  static edit(params) {
    const id = params['id']
    return apiDispatcher(EDIT(this.resourceName(), id, { ...params, id: null }))
  }

  static uploadImage(params) {
    const id = params['id']
    return apiDispatcher(UPLOAD_IMAGE('roster', id, params['image']))
  }
}
